import { Optional } from '@frontend/sports/common/core/utils/extended-types';
import { ConfirmationDialogButtonType, ConfirmationDialogService, IConfirmationDialogModel } from '@frontend/sports/modal/feature';

export abstract class EditBetBetDialogBaseService {
    private isDialogShown = false;

    protected constructor(private confirmationDialog: ConfirmationDialogService) {}

    show(): Promise<Optional<ConfirmationDialogButtonType>> {
        if (this.isDialogShown) {
            return Promise.resolve(void 0);
        }
        this.isDialogShown = true;

        const ref = this.confirmationDialog.showDialog(this.getDialogModel());

        // Catch closing dialog using backdrop click
        return ref.result.catch(() => {}).finally(() => (this.isDialogShown = false));
    }

    protected abstract getDialogModel(): IConfirmationDialogModel;
}
